export type BankAccountDetailsStep =
  | 'consentGiven'
  | 'bankName'
  | 'bankType'
  | 'bankTypeOther'
  | 'branchName'
  | 'accountType'
  | 'accNum'
  | 'nameKana'
  | 'finalConfirm';

export const DONE_STEP_ID = '__done__';

export function stepQuestionKey(step: BankAccountDetailsStep): string {
  return `submitDocuments.bankAccountDetails.steps.${step}`;
}

